<template>
    <div class="DM_cashBackList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item style="width:187px;">
                    <el-radio v-model="searchForm.type" :label="1" @change="typeChange">团队</el-radio>
                    <el-radio v-model="searchForm.type" :label="2" @change="typeChange">直营</el-radio>
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="searchForm.brand_id"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="请选择终端类型"
                    >
                        <el-option
                            v-for="(item,index) in brandList"
                            :label="item.name"
                            :value="item.id"
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size="medium"
                        v-model="searchForm.terminal_type"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="请选择终端类型">
                        <el-option label="银盛POS" value="1"></el-option>
						<el-option label="手机POS" value="2"></el-option>
						<el-option label="杉德POS" value="3"></el-option>
						<el-option label="联动POS" value="4"></el-option>
                        <el-option label="海科POS" value="5"></el-option>
                        <el-option label="银盛尊享POS" value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size="medium"
                        v-model="searchForm.activity_type"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="请选择流量卡类型">
                        <el-option label="首年流量卡" value="1"></el-option>
                		<el-option label="二阶段流量卡" value="2"></el-option>
                		<el-option label="三阶段流量卡" value="3"></el-option>
                		<el-option label="四阶段流量卡" value="4"></el-option>
                        <el-option label="五阶段流量卡" value="5"></el-option>
                        <el-option label="六阶段流量卡" value="6"></el-option>
                        <el-option label="七阶段流量卡" value="7"></el-option>
                        <el-option label="八阶段流量卡" value="7"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="searchForm.terminal_sn" placeholder="请输入SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="searchForm.phone" placeholder="请输入直属代理账号"></el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <el-input clearable v-model="searchForm.name" placeholder="请输入归属代理名称"></el-input>
                </el-form-item> -->
                <el-form-item v-if="level < 2">
                	<el-input size clearable v-model="searchForm.p2_phone" placeholder="请输入所属代理账号"></el-input>
                </el-form-item>
                
                <el-form-item v-if="level < 2">
                	<el-input size clearable v-model="searchForm.p2_agent_no" placeholder="请输入所属代理编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
                    <el-button
                        size="small"
                        type="primary"
                        icon="el-icon-download"
                        :loading="downLoading"
                        @click="handleDownLoad(searchForm)"
                    >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <div style="margin-bottom: 10px;">
                <div class="tableTitle">
                    <span class="st-label">交易总额：</span>
                    <span class="st-word-aux">{{tableTitle.total_money}}</span>
                </div>
<!--                <div class="tableTitle" v-if="level >1 ">
                    <span class="st-label">分润总额：</span>
                    <span class="st-word-aux">{{tableTitle.my_money}}</span>
                </div> -->
                <div class="tableTitle">
                    <span class="st-label">交易笔数：</span>
                    <span class="st-word-aux">{{tableTitle.total_count}}&nbsp;笔</span>
                </div>
            </div>
            <el-table
                :data="backList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
                max-height="500px"
            >
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 政策 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brand_name"
                    label="政策"
                    min-width="150"
                ></el-table-column>
                <!-- 终端类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminal_type_text"
                    label="终端类型"
                    min-width="150"
                ></el-table-column>
                <!-- 终端SN -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminal_sn"
                    label="终端SN"
                    min-width="120"
                ></el-table-column>
              <!-- 终端SN -->
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="activity_type_text"
                  label="流量卡类型"
                  min-width="120"
              ></el-table-column>
				<!-- 终端归属代理名称 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="agent_no"
				    label="终端直属代理编号"
				    min-width="150"
				
				></el-table-column>
                <!-- 终端归属代理名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="name"
                    label="终端直属代理名称"
                    min-width="150"
                ></el-table-column>
                <!-- 终端归属代理账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="终端直属代理账号"
                    min-width="150"
                >
                </el-table-column>
                <el-table-column v-if="level < 2" header-align="center" align="center" prop="p2_nickname" label="终端所属代理昵称"
                	min-width="150"></el-table-column>
                <el-table-column v-if="level < 2"  header-align="center" align="center" prop="p2_phone" label="终端所属代理账号" min-width="150">
                </el-table-column>
                <!-- 所属代理商编号 -->
                <el-table-column v-if="level < 2"  header-align="center" align="center" prop="p2_agent_no" label="终端所属代理编号" min-width="150">
                </el-table-column>
                <!-- 模版 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="rule"
                    label="政策模版"
                    min-width="120"
                ></el-table-column>
                <!-- 奖励时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="award_time"
                    label="奖励时间"
                    min-width="150"
                ></el-table-column>
                <!-- 奖励金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="deposit"
                    label="流量卡实际扣款金额"
                    min-width="120"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.is_deal == 1" @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
                        <span v-else> 无分润</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <back-info v-if="detail.isShow" :detail="detail" @infoClose="infoClose"></back-info>
    </div>
</template>

<script>
import backInfo from './DM_flowBackInfo';
export default {
    name: "DM_flowBackList",
    data() {
        return {
            tableTitle: {
                // my_money: 0,
                total_money: 0,
                total_count: 0,
            },
            detail: { //详情
                isShow: false,
                info: {}
            },
            brandList: [],
            searchForm: {
                page: 1,
                limit: 10,
                brand_id: '', //终端类型
                terminal_sn: '', //sn
                name: '', //归属人姓名
                phone: '', //归属人账号
                start_time: '',
                end_time: '',
                type: 1,
                terminal_type:'',
                activity_type:'',
                p2_phone:'',
                p2_agent_no:'',
            },
            currentDate: '',
            pickerOptions: {},
            rangeDate: [], //时间范围
            backList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
            downLoading: false, //导出loading
            level: sessionStorage.getItem('level')
        }
    },
    mounted() {
        this.handleDefaultTime();
        this.$api.post('brand/brand_list', {}, res => { //获取终端类型
            if (res.code == 0) {
                this.brandList = res.data.list;
            } else {
                this.$$message.success(res.msg);
            }
        });
        this.getData({
            page: 1,
            limit: 10,
            type: 1,
        })
    },
    components: {
        backInfo
    },
    methods: {
        typeChange(val) { //监听radio
            this.searchForm.type = val;
            this.currentPage = 1; //重置分页
            this.searchForm.page = 1; //重置
            // 表单提交
            this.getData();
        },
        onSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData();
        },
        handleInfo(row) { //详情
            this.detail.isShow = true;
            this.detail.info = row;
        },
        infoClose() {
            this.detail.isShow = false;
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData();
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData();
        },
        getData() { //获取数据
            this.loading = true;
            this.$api.post("terminal_flow_back/flow_back_list", this.searchForm, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.backList = res.data.list;
                this.tableTitle= {
                    // my_money: data.my_money,
                    total_money: data.total_money,
                    total_count: data.total_count,
                },
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleDownLoad(searchForm) { //导出
			let reqData = {
				type: 5,
				value: JSON.stringify(searchForm)
			};
			
			this.downLoading = true; 
			this.$api.post('export/add', reqData, res => {
				if (res.code == 0) {
					this.$message.success(res.msg);
					this.downLoading = false;
				} else {
					this.$message.error(res.msg);
					this.downLoading = false;
				}
			
			})
        },
        handleDefaultTime() { //默认获取三十天
            let date =this.$moment().endOf('day').format('x');
            this.searchForm.end_time = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
            this.searchForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.searchForm.start_time, this.searchForm.end_time];
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.searchForm.start_time, this.searchForm.end_time];
        },
    }
};
</script>

<style lang="scss" scope>
.DM_cashBackList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
    .el-date-editor .el-range-input,
    .el-date-editor .el-range-separator {
        font-size: 12px;
    }
    .el-popover__title {
        font-size: 12px;
        font-weight: 700;
    }
    .tableTitle {
        display: inline-block;
        margin-right: 20px;
    }
}
</style>
